<template>
  <wrapper>
    <main class="main-content-wrapper">
      <card>
        <div class="row mb-4">
            <div class="col-lg-3">
                Batch Number
                <input
                    type="text"
                    name=""
                    class="form-control"
                    placeholder="Contoh : 6080-SN..."
                    v-model="searchBatchNumber"
                />
            </div>
            <div class="col-lg-3">
                SN/SC
                <input
                    type="text"
                    name=""
                    class="form-control"
                    placeholder="Masukkan SN/SC..."
                    v-model="searchSn"
                />
            </div>
            <div class="col-lg-3">
                No. Item
                <input
                    type="text"
                    name=""
                    class="form-control"
                    placeholder="Contoh : 6080"
                    v-model="searchNoItem"
                />
            </div>
            <div class="col-lg-3">
                Source
                <multiselect
                    v-model="searchSource"
                    :options="sourceOptions"
                    :allow-empty="false"
                    :select-label="'Type'"
                    :deselect-label="''"
                    placeholder="Select Source"
                ></multiselect>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                Nama Item
                <input
                    type="text"
                    name=""
                    class="form-control"
                    placeholder="Cari berdasarkan nama item..."
                    v-model="searchItemName"
                />
            </div>
            <div class="col-lg-6">
               <div class="d-flex justify-content-end mt-4">
                    <div>
                        <button
                            class="btn btn-primary default-btn"
                            @click="searchData()"
                        >
                            Search
                        </button>
                    </div>
                    <div>
                        <button
                            class="btn reset-btn default-btn ml-2"
                            @click="resetSearch()"
                        >
                            Reset
                        </button>
                    </div>
                </div>
            </div>
        </div>
        
      </card>
      <br />
      <div class="mb-3" v-if="selectedRows.length > 0">
        <button
            class="btn btn-primary default-btn mr-2"
            @click="downloadLabel"
            :disabled="loadingButtonDownload"
        >
            <i class="fas fa-download"></i> Download Label
            <img src="~@/assets/images/2.gif" style="height: 24px;" v-if="loadingButtonDownload == true"></img>
        </button>
        <span class="selected-count-text">{{ selectedRows.length }} unit(s) selected</span>
      </div>
      <!-- Table Card -->
    <div class="table-card">
      <table class="custom-table">
        <thead>
          <tr>
            <th class="col-check">
              <input type="checkbox" class="custom-checkbox" @change="selectAllRows" :checked="checkIsSelectAll()"/>
            </th>
            <th class="col-batch">BATCH NUMBER</th>
            <th class="col-sn">SN/SC</th>
            <th class="col-noitem">NO ITEM</th>
            <th>NAMA ITEM</th>
            <th class="col-source" style="text-align:right; padding-right: 20px;">SOURCE</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, i) in batchList" :key="i">
            <td>
              <input type="checkbox" class="custom-checkbox" v-model="selectedRows" :value="row"/>
            </td>
            <td><span class="batch-number">{{ row.batchNumber }}</span></td>
            <td>{{ row.stockCode }}</td>
            <td>{{ row.itemCode }}</td>
            <td>{{ row.itemName}}</td>
            <td style="text-align:right; padding-right: 20px;">
              <span :class="getStatusBadge(row.source)" class="badge-source">
                {{ row.source }}
              </span>
            </td>
          </tr>
          <tr v-if="batchList.length === 0">
            <td colspan="6" class="text-center text-muted py-4">Tidak ada data</td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <!-- Footer -->
    <div class="table-footer">
      <div class="showing-select">
        <span>Showing data</span>
        <select v-model.number="itemPerPage" @change="toDataPerPage()">
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
        </select>
        <span>Total Data {{ totalData }}</span>
      </div>
      <div class="pagination-wrap">
        <button class="btn-page" :disabled="currentPage === 1" @click="toDataPage(currentPage - 1)">&#8249;</button>
        <div class="btn-page-label">Page {{ currentPage }} of {{ totalPage }}</div>
        <button class="btn-page" :disabled="currentPage === totalPage || totalPage === 0" @click="toDataPage(currentPage + 1)">&#8250;</button>
      </div>
    </div>

    </main>
    <!-- /#page-content-wrapper -->
  </wrapper>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import SideBar from "../SideBar";
import { Wrapper, Card } from "../Layout";

export default {
  name: "BatchNumberListPage",
  components: {
    SideBar,
    Multiselect,
    Wrapper,
    Card,
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      batchList: [],
      sourceOptions:['Copotan','Pembelian', 'Dummy'],
      searchBatchNumber: "",
      searchSn: "",
      searchNoItem: "",
      searchSource:'',
      searchItemName : '',
      admin: "",
      adminId: "",
      selectedRows : [],
      loadingButtonDownload : false,

      permission: [],
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      loadingButtonProcess: false,
      loadingButtonNext: false,
      totalPage: 0,
      totalData: 0,
      currentPage: 1,
      loadingTable: true,
      itemPerPage: 10,
      selectedPoData : '',
      selectedPrData : '',
    };
  },
  watch: {
      selectedRows: function (a) {
        localStorage.setItem("selectedBatches", JSON.stringify(a));
      },
    },
  methods: {
    getStatusBadge(source) {
        switch(source) {
            case 'Copotan' : {
                return 'badge-copotan'
            }
            case 'Pembelian' : {
                return 'badge-pembelian'
            }
            default : {
                return 'badge-dummy'
            }
        }
    },
    forceFileDownload(response, filename) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();
      this.selectedRows = []
    },
    downloadLabel() {
        this.loadingButtonDownload = true;
        const downloadItems = this.selectedRows.map(item => {
            return item.batchNumber
        })
      this.$http.post( process.env.DOWNLOAD_PR_LABEL,
        {
          data : downloadItems,
          type : 'batch_number'
        },
        {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
          responseType: "arraybuffer",
        }
      )
      .then((res) => {
        const responseType = res.config.responseType
    
        let responseStatus = ''
        let responseMessage = ''
        if (responseType && responseType == 'arraybuffer') {
          const responseBufferJSON = Buffer.from(res.data).toJSON();
          if (responseBufferJSON.data[0] == 123) {
              let responseString = ''
              responseBufferJSON.data.forEach(item => {
                responseString = responseString + String.fromCharCode(item)
              })
              const response = JSON.parse(responseString)
              responseStatus = response.status
              responseMessage = response.message
          } else {
            this.forceFileDownload(res,"label_batches.pdf");
            this.loadingButtonDownload = false
          }
        }
        if(responseStatus == 400) {  
          swal("Sorry", responseMessage , "error", {
            button: "Close"
          });
          this.loadingButtonDownload = false
        }
      })
      .catch(error => {
        swal("Sorry", error.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.status == 401) {
            this.handleLogout()
          }
        })
      });
    },
    checkIsSelectAll() {
        let checked = 0
        this.batchList.forEach(data => {
          if(this.selectedRows.find(item => item.batchNumber == data.batchNumber)) {
            checked += 1
          }
        })
  
        if( this.batchList.length > 0 && checked == this.batchList.length) {
          return true
        } else {
          return false
        }
    },
    selectAllRows() {
        const isSelectAll = this.checkIsSelectAll()
        let datas = this.batchList
        if (!isSelectAll) {
          datas.forEach(item => {
            if(!this.selectedRows.find(data => data.batchNumber == item.batchNumber)) {
              this.selectedRows.push(item)
            }
          })
          localStorage.setItem("selectedBatches", JSON.stringify(this.selectedRows))
        } else {
         datas.forEach(item => {
            const index = this.selectedRows.findIndex(data => item.batchNumber == data.batchNumber); 
            if(this.selectedRows.find(data => item.batchNumber == data.batchNumber)) {
              this.selectedRows.splice(index, 1);
            }
          })
          localStorage.setItem("selectedBatches", JSON.stringify(this.selectedRows))
        }
    },
    toggleAll() {

    },
    resetSearch() {
      this.searchBatchNumber = "";
      this.searchSn = "";
      this.searchNoItem = "";
      this.searchSource ='';
      this.searchItemName = '';
      this.currentPage = 1;
      this.itemPerPage = 10;
      this.searchData();
    },
    searchData() {
      this.$router.push(
        {
          path:'/catalog/batch-number-list', 
          query: {
            batchNumber: this.searchBatchNumber,
            sn: this.searchSn,
            noItem: this.searchNoItem,
            source : this.searchSource,
            itemName : this.searchItemName,
            page: 1,
            itemPerPage: this.itemPerPage,
          }
        }
      )
    },
    toDataPage(pagePost) {
      this.$router.push(
        {
          path:'/catalog/batch-number-list', 
          query: {
            batchNumber: this.searchBatchNumber,
            sn: this.searchSn,
            noItem: this.searchNoItem,
            source : this.searchSource,
            itemName : this.searchItemName,
            page: pagePost,
            itemPerPage: this.itemPerPage,
          }
        }
      )
    },
    toDataPerPage() {
      this.$router.push(
        {
          path:'/catalog/batch-number-list', 
          query: {
            batchNumber: this.searchBatchNumber,
            sn: this.searchSn,
            noItem: this.searchNoItem,
            source : this.searchSource,
            itemName : this.searchItemName,
            page: 1,
            itemPerPage: this.itemPerPage,
          }
        }
      )
    },
    toPage(e) {
      this.$router.push(e);
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(
          process.env.LOGOUT,
          {},
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        );
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          });
          return;
        }
      } catch (error) {
        if (error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          });
          return;
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem("changeCatalogPermission");
      this.$router.push("/");
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    cekPermission() {
      this.permission = localStorage
        .getItem("roles")
        .replace(/"/g, "")
        .replace("[", "")
        .replace("]", "")
        .split(",");
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true;
        }
        if (this.permission[i] == "2.1") {
          this.viewOrder = true;
        }
        if (this.permission[i] == "2.2") {
          this.editOrder = true;
        }
        if (this.permission[i] == "3.1") {
          this.viewReturn = true;
        }
        if (this.permission[i] == "3.2") {
          this.editReturn = true;
        }
        if (this.permission[i] == "4.1") {
          this.viewProduct = true;
        }
        if (this.permission[i] == "4.2") {
          this.editProduct = true;
        }
        if (this.permission[i] == "5.1") {
          this.viewPairing = true;
        }
        if (this.permission[i] == "5.2") {
          this.editPairing = true;
        }
        if (this.permission[i] == "6") {
          this.viewReconcile = true;
        }
        if (this.permission[i] == "7.1") {
          this.viewResolution = true;
        }
        if (this.permission[i] == "7.2") {
          this.editResolution = true;
        }
        if (this.permission[i] == "8.1") {
          this.viewLessor = true;
        }
        if (this.permission[i] == "8.2") {
          this.editLessor = true;
        }
        if (this.permission[i] == "9.1") {
          this.viewLessee = true;
        }
        if (this.permission[i] == "9.2") {
          this.editLessee = true;
        }
        if (this.permission[i] == "10") {
          this.viewEmployee = true;
        }
      }
      if (this.viewProduct == false) {
        this.$router.push("/");
      }
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    toDetail(id) {
      this.$router.push("/product/detail/" + id);
    },
    async getData() {
      try {
        this.loadingTable = true;
        this.searchBatchNumber = this.$route.query.batchNumber;
        this.searchSn = this.$route.query.sn
        this.searchNoItem = this.$route.query.noItem
        this.searchSource = this.$route.query.source;
        this.searchItemName = this.$route.query.itemName
        this.currentPage = parseInt(this.$route.query.page);
        this.itemPerPage = parseInt(this.$route.query.itemPerPage);
   
        const response = await this.$http.post(
          process.env.GET_PURCHASE_BATCH_LIST,
          { 
            batchNumber: this.searchBatchNumber,
            stockCode: this.searchSn,
            itemCode: this.searchNoItem,
            itemName: this.searchItemName,
            source: this.searchSource,
            itemPerPage:10,
            page:this.currentPage
          },
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        );
      
        if (response.data.status == 400) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          });
          // this.handleLogout();
        } else {
          if (this.currentPage > response.data.data.totalPage) {
            this.searchData(1);
          } else {
            this.batchList = response.data.data.data
            this.totalPage = response.data.data.totalPage;
            this.currentPage = response.data.data.currentPage;
            this.totalData = response.data.data.totalData;
            this.loadingTable = false;
          }
        }
      } catch (error) {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then((v) => {
          if (error.response.data.status == 401) {
            this.handleLogout();
          }
        });
      }
    },

    sendLog(x, y) {
      var today = new Date();
      var month = today.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var dateDay = today.getDate();
      if (dateDay < 10) {
        dateDay = "0" + dateDay;
      }
      var hours = today.getHours();
      if (hours < 10) {
        hours = "0" + hours;
      }
      var minutes = today.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var second = today.getSeconds();
      if (second < 10) {
        second = "0" + second;
      }
      var date = today.getFullYear() + "-" + month + "-" + dateDay;
      var time = hours + ":" + minutes + ":" + second;
      var dateTime = date + " " + time;
      var admin = this.admin;
      var command = "add-logs";
      var productName =
        this.productNameChoose == null
          ? this.productNameChoose
          : this.productNameChoose.replace(this.spaceRegex, " ");
      if (y == "34") {
        var newShowing = this.showingChoose;
        this.$http
          .post(
            process.env.LOG_URL + "/product/" + x,
            {
              codeLogs: y,
              params: [productName, newShowing],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$http
          .post(
            process.env.LOG_URL + "/product/" + x,
            {
              codeLogs: y,
              params: [productName],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  async created() {
    this.admin = localStorage.getItem("admin_name");
    this.adminId = localStorage.getItem("admin_id");
    this.selectedRows = localStorage.getItem("selectedBatches") ? JSON.parse(localStorage.getItem("selectedBatches")) : [];
    this.cekLogin();
    this.cekPermission();
    await this.getData();
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .selected-count-text {
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.15px;
        color: #4B5563;
    }
    /* Checkbox */
    .custom-checkbox { width: 16px; height: 16px; cursor: pointer; accent-color: #247FEC; }
    /* table */
    .table-card {
      background: #fff;
      border: 1px solid #D1D9E2;
      border-radius: 8px;
      overflow: hidden;
    }
    .custom-table { width: 100%; border-collapse: collapse; }
    .custom-table thead th {
      background: #f8f9fa;
      color: #6c757d;
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      padding: 12px 16px;
      border-bottom: 1px solid #e9ecef;
      white-space: nowrap;
    }
    .custom-table tbody td {
      padding: 14px 16px;
      font-size: 13px;
      color: #2E3646;
      border-bottom: 1px solid #e9ecef;
      vertical-align: middle;
    }
    .custom-table tbody tr:last-child td { border-bottom: none; }
    .custom-table tbody tr:hover { background: #f8fbff; }

    .batch-number { font-weight: 700; color: #2E3646; font-size: 13px; }

    .badge-source {
        display: inline-block;
        padding: 5px 16px;
        border-radius: 20px;
        font-size: 13px;
        font-weight: 500;
    }

    .badge-pembelian {
        background: #EDF0FF;
        color: #432DD7;
        border: 1px solid #C7CEFF;
    }

    .badge-copotan {
        background: #FEF0FF;
        color: #B800C9;
        border: 1px solid #F0AAFF;
    }

    .badge-dummy {
        background: #F0F4F8;
        color: #8A94A6;
        border: 1px solid #D1D9E2;
    }

     /* Footer */
    .table-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 14px 0;
    }
    .showing-select {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 13px;
      color: #495057;
    }
    .showing-select select {
      font-size: 13px;
      border: 1px solid #D1D9E2;
      border-radius: 6px;
      padding: 4px 10px;
      color: #2E3646;
      height: 32px;
    }
    .pagination-wrap { display: flex; align-items: center; gap: 6px; }
    .btn-page {
      background: #fff;
      border: 1px solid #D1D9E2;
      border-radius: 6px;
      width: 32px; height: 32px;
      display: flex; align-items: center; justify-content: center;
      cursor: pointer; font-size: 14px; color: #6c757d;
    }
    .btn-page:hover:not(:disabled) { background: #f0f4ff; }
    .btn-page:disabled { opacity: 0.4; cursor: not-allowed; }
    .btn-page-label {
      background: #247FEC;
      color: #fff;
      border: none;
      border-radius: 6px;
      padding: 4px 16px;
      height: 32px;
      font-size: 13px;
      font-weight: 600;
      display: flex; align-items: center;
    }

    /* Dot indicator */
    .dot-indicator {
      width: 14px; height: 14px;
      background: #247FEC;
      border-radius: 50%;
      margin-left: 4px;
    }

    /* Select all checkbox column */
    .col-check { width: 40px; }
    .col-batch { width: 200px; }
    .col-sn { width: 130px; }
    .col-noitem { width: 100px; }
    .col-source { width: 120px; text-align: right; }
        
.text-main-color {
  color: #2E3646;
}

.default-btn {
  font-weight: 600;
  height: fit-content;
  font-size: .875rem;
  padding: .5rem .75rem;
  border-radius: .375rem;
}

.icon-btn {
  border-radius: 8px;
  padding: 4px;
  background: #ffffff;
  width: 34px;
}

.icon-btn-blue {
  border: 1px solid #247FEC66;
}

.icon-btn-orange {
  border: 1px solid #F2641966;
}

.icon-btn-red {
  border: 1px solid #FF344480;
}

.icon-btn-green {
  border: 1px solid #C8DFCA;
}

.reset-btn {
  border: 1px solid #D1D9E2;
  color: #2E3646;
}

.field-label {
  width: 160px;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797fb;
  color: #fff;
  border: 1px solid #2797fb;
}

.p8 a:hover {
  text-decoration: none;
}
.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797fb;
}

.total-data {
  font-size: 14px;
  color: #343a40;
}

.right-dropdown {
  margin-left: 7px;
}

.main-content-wrapper {
  padding: 1rem 4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalog/BatchNumberListPage.vue